import { Record } from 'immutable';
import { DonorBasicInfo, ApiDonorBasicInfo  } from './DonorBasicInfo';
import { DonorPhysicalInfo, ApiDonorPhysicalInfo  } from './DonorPhysicalInfo';
import { DonorSemen, ApiDonorSemen  } from './DonorSemen';
import { DonorStd, ApiDonorStd  } from './DonorStd';
import { DonorRequest, ApiDonorRequest } from './DonorRequest';
import { DonorReviewSummary, ApiDonorReviewSummary } from './DonorReviewSummary';
import { DonorReview, ApiDonorReview } from './DonorReview';
import { UserType } from '../types';
import Util from '../util';

export type ApiDonorPhoto = {
  id: number;
  image_url: string;
  status: string;
  comments: string;
} | null;

export type ApiDonor = {
  name: string;
  user_type: UserType;
  user_no: number;
  count: number;
  donor_basic_info: ApiDonorBasicInfo;
  donor_physical_info: ApiDonorPhysicalInfo;
  donor_semen: ApiDonorSemen;
  donor_std: ApiDonorStd;
  donor_request: ApiDonorRequest;
  donor_photo: ApiDonorPhoto;
  active_in_hour: number;
  last_activity_on: string;
  kyc_status: string;
  donor_review_summary?: ApiDonorReviewSummary;
  donor_reviews_received?: ApiDonorReview[];
};

const DonorBase = Record({
  name: "",
  userType: "" as UserType,
  userNo: 0,
  count: 0,
  activeInHour: 9999,
  lastActivityOn: "",
  kycStatus: "",
  photoUrl: "" as string,
  photoStatus: "" as string,
  photoComments: "" as string,
  basicInfo: new DonorBasicInfo(),
  physicalInfo: new DonorPhysicalInfo(),
  semen: new DonorSemen(),
  std: new DonorStd(),
  request: new DonorRequest(),
  reviewSummary: undefined as DonorReviewSummary | undefined,
  reviews: [] as DonorReview[],
});

export class Donor extends DonorBase {
  constructor(apiDonor?: ApiDonor) {
    super({
      name: apiDonor?.name,
      userType: apiDonor?.user_type,
      userNo: apiDonor?.user_no,
      count: apiDonor?.count || 0,
      activeInHour: apiDonor?.active_in_hour,
      lastActivityOn: apiDonor?.last_activity_on,
      kycStatus: apiDonor?.kyc_status,
      photoUrl: apiDonor?.donor_photo?.image_url || "",
      photoStatus: apiDonor?.donor_photo?.status || "",
      photoComments: apiDonor?.donor_photo?.comments || "",
      basicInfo: new DonorBasicInfo(apiDonor?.donor_basic_info),
      physicalInfo: new DonorPhysicalInfo(apiDonor?.donor_physical_info),
      semen: new DonorSemen(apiDonor?.donor_semen),
      std: new DonorStd(apiDonor?.donor_std),
      request: new DonorRequest(apiDonor?.donor_request),
      reviewSummary: apiDonor?.donor_review_summary ? new DonorReviewSummary(apiDonor.donor_review_summary) : undefined,
      reviews: apiDonor?.donor_reviews_received ? apiDonor.donor_reviews_received.map(review => new DonorReview(review)) : [],
    })
  }

  readonly initialName: string = this.name.split('').join('.');

  readonly activeInText: string = Util.toActiveInWord(this.activeInHour);

  readonly isKycCertified: boolean = ['SUBMITTED', 'AUTO_CERTIFIED', 'MAN_CERTIFIED'].includes(this.kycStatus);

  readonly isKycCertifiedStrict: boolean = ['AUTO_CERTIFIED', 'MAN_CERTIFIED'].includes(this.kycStatus);

  readonly isPhotoVisible: boolean = (this.std.certified || this.semen.certified) && ['SUBMITTED', 'CERTIFIED'].includes(this.photoStatus);

  readonly visiblePhotoUrl: string = this.isPhotoVisible ? this.photoUrl : '';
}
